import React from "react";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import './style.scss'


const Upcoming = () => {
  let navigate = useNavigate();
  const gotoApply = () => {
    navigate(`${"/apply-to-launch"}`);
  };

  const noData = (
    <>
      <img className="no-data" src="/images/empty.png" alt="" />
      <p>Currently there is no projects</p>
    </>
  );


  return (
    <>
      <div className="main-setion upcoming">
        <div className="container">
          <div className="main-title">
            <h3 className="title new">Upcoming sales</h3>
          </div>

          {isMobile ? (
            <>
              <div className="slide-row-funded">
                <div className="slider-chain mobile">
                  <div className="empty-colspan">{noData}</div>
                </div>
                <div className="btn-group">
                  <div className="btn btn-show-more apply new" onClick={gotoApply}>
                    Apply to launch
                  </div>
                  <div className="btn btn-show-more new">
                    Explore projects
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="slide-row-funded">
                <div className="slider-chain mobile">
                  <div className="columns center funded">
                    <div className="empty-colspan">{noData}</div>
                  </div>
                  <div className="btn-group">
                    <div className="btn btn-show-more apply new" onClick={gotoApply}>
                      Apply to launch
                    </div>
                    <div className="btn btn-show-more new">
                      Explore projects
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default Upcoming;
